import { useMemo, useState, useEffect } from 'react';
import useNavigation from '../useNavigation/useNavigation';

const useTransitionEnd = () => {
  const navigation = useNavigation();
  const isStackNavigator = useMemo(
    () => navigation.getState()?.type === 'stack',
    [navigation],
  );
  const [transitionEnded, setTransitionEnded] = useState(!isStackNavigator);

  useEffect(() => {
    const unsubscribe = navigation.addListener('transitionEnd', () => {
      setTransitionEnded(true);
    });

    // Used for backup in case transitionEnd is not called
    const timeout = setTimeout(() => setTransitionEnded(true), 250);

    return () => {
      unsubscribe();
      clearTimeout(timeout);
    };
  }, [navigation]);

  return transitionEnded;
};

export default useTransitionEnd;
